<template>
  <div class="promote">
    <van-nav-bar
      :title="title"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    />

    <!-- 兑换码输入框 -->
    <div class="top-content box-shadow">
      <div class="_input_1ywvk_30">
        <div class="ui-input" :class="{ 'ui-input--focused': isFocused }">
          <i
            class="lobby-image lobby-image dhm-svg"
            data-load-strategy="loading-set@0:lazy@0"
            data-status="success"
            data-thumb="0"
            data-id="7a22894a-f2b4-4351-8668-3dbf1243e5d9"
            data-src="/siteadmin/skin/lobby_asset/common/web/common/input_icon_dhm.svg"
            style="
              display: inline-flex;
              justify-content: center;
              align-items: center;
              color: var(--theme-text-color);
              margin-right: 10px;
            "
            ><svg
              width="1em"
              height="1em"
              fill="currentColor"
              class=""
              viewBox="0 0 48 48.001"
            >
              <defs style="display: none">
                <clipPath id="0085080cb835f0d35b07e9d879acd7f2-clip-path">
                  <path
                    id="0085080cb835f0d35b07e9d879acd7f2-Union_151"
                    data-name="Union 151"
                    d="M-137-2471v-4h4v4Zm-44,0v-4h4v4Zm44-44v-4h4v4Zm-44,0v-4h4v4Z"
                    transform="translate(181 2519)"
                  ></path>
                </clipPath>
              </defs>
              <g
                id="0085080cb835f0d35b07e9d879acd7f2-input_icon_dhm"
                transform="translate(-772 -2123)"
              >
                <g
                  id="0085080cb835f0d35b07e9d879acd7f2-底层"
                  transform="translate(772 2123)"
                >
                  <g
                    id="0085080cb835f0d35b07e9d879acd7f2-Mask_Group_1"
                    data-name="Mask Group 1"
                    transform="translate(0)"
                    opacity="0"
                    clip-path="url(#0085080cb835f0d35b07e9d879acd7f2-clip-path)"
                  >
                    <path
                      id="0085080cb835f0d35b07e9d879acd7f2-底层-2"
                      data-name="底层"
                      d="M2,1A1,1,0,0,0,1,2V46a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2M2,0H46a2,2,0,0,1,2,2V46a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
                      transform="translate(0 0)"
                    ></path>
                  </g>
                </g>
                <g
                  id="0085080cb835f0d35b07e9d879acd7f2-icon_dl_dhm"
                  transform="translate(771.008 2126.05)"
                >
                  <path
                    id="0085080cb835f0d35b07e9d879acd7f2-Union_146"
                    data-name="Union 146"
                    d="M-3883.873,1990.67h-32.182v-33.6h32.638a.912.912,0,0,1,.837.434,2.071,2.071,0,0,1,.339.96,2.155,2.155,0,0,1-.241,1.08,1.471,1.471,0,0,1-.866.744,2.038,2.038,0,0,0-1.413,1.7,1.655,1.655,0,0,0,.264,1.126,2.219,2.219,0,0,0,1.152.813,2.184,2.184,0,0,1,.958.794,2.392,2.392,0,0,1,.382,1.1,1.842,1.842,0,0,1-.264,1.081,1.625,1.625,0,0,1-.933.719,2.137,2.137,0,0,0-1.251.768,2,2,0,0,0-.135,2.4,2.258,2.258,0,0,0,1.1.892,1.985,1.985,0,0,1,1.005.814,2.421,2.421,0,0,1,.358,1.128,2.141,2.141,0,0,1-.241,1.152,1.979,1.979,0,0,1-.794.813,2.4,2.4,0,0,0-1.738,1.877,1.917,1.917,0,0,0,1.272,1.824,1.888,1.888,0,0,1,.959.84,2.444,2.444,0,0,1,.405,1.2,2.2,2.2,0,0,1-.24,1.147,1.587,1.587,0,0,1-.864.72,2.186,2.186,0,0,0-1.248.74,1.828,1.828,0,0,0-.48,1.129,2,2,0,0,0,.336,1.221,2.827,2.827,0,0,0,1.175,1.005,1.639,1.639,0,0,1,.768.839,2.456,2.456,0,0,1,.164,1.107,2.074,2.074,0,0,1-.383.984.907.907,0,0,1-.772.435Zm-6.221-10.463a4.065,4.065,0,0,0,1.316-.721,3.308,3.308,0,0,0,.89-1.221v.166a4.036,4.036,0,0,0,.338-1.944,3.072,3.072,0,0,0-.5-1.872,3.479,3.479,0,0,0-1.179-1.053,2.971,2.971,0,0,0,1.056-.985,2.835,2.835,0,0,0,.43-1.679,3.738,3.738,0,0,0-.289-1.486,3.735,3.735,0,0,0-.814-1.18,3.634,3.634,0,0,0-1.269-.745,4.123,4.123,0,0,0-1.566-.285,4.6,4.6,0,0,0-1.533.261,3.682,3.682,0,0,0-1.249.72,3.794,3.794,0,0,0-.837,1.149,3.975,3.975,0,0,0-.338,1.56h2.4a1.613,1.613,0,0,1,.479-1.155,1.559,1.559,0,0,1,1.129-.405,1.713,1.713,0,0,1,1.106.406,1.563,1.563,0,0,1,.48,1.224,1.841,1.841,0,0,1-.39,1.152,1.542,1.542,0,0,1-1.248.48h-.36v2.04h.36a1.864,1.864,0,0,1,1.341.48,1.952,1.952,0,0,1,.456,1.3,1.864,1.864,0,0,1-.48,1.346,1.737,1.737,0,0,1-1.248.453,1.984,1.984,0,0,1-.671,0,1.348,1.348,0,0,1-.549-.312,1.44,1.44,0,0,1-.385-.531,2.294,2.294,0,0,1-.169-.744h-2.4a4.6,4.6,0,0,0,.36,1.728,3.471,3.471,0,0,0,.907,1.177,3.258,3.258,0,0,0,1.32.672,5.278,5.278,0,0,0,1.536.216,5.452,5.452,0,0,0,1.571-.21Zm-9.936-10.269a1.776,1.776,0,0,1,.409,1.174,1.68,1.68,0,0,1-.167.79,2.639,2.639,0,0,1-.5.77l-4.8,5.594v2.136h7.848v-2.136l-4.97-.074,3.624-4.175.578-.72a5.437,5.437,0,0,0,.432-.674,2.79,2.79,0,0,0,.265-.72,2.883,2.883,0,0,0,0-.843,4.158,4.158,0,0,0-.291-1.581,3.133,3.133,0,0,0-.813-1.179,3.857,3.857,0,0,0-1.224-.745,4.848,4.848,0,0,0-1.584-.263,4.792,4.792,0,0,0-1.559.262,3.43,3.43,0,0,0-1.252.746,3.471,3.471,0,0,0-.841,1.178,4.208,4.208,0,0,0-.286,1.584h2.4a1.736,1.736,0,0,1,.145-.763,1.146,1.146,0,0,1,.362-.506,1.092,1.092,0,0,1,.5-.286,2.345,2.345,0,0,1,.576,0h.1a1.478,1.478,0,0,1,1.052.429Zm-10.079,10.461h2.4v-12.815h-2.4l-2.64,2.28v2.544l2.64-2.4Zm-19.2,9.6a3.75,3.75,0,0,1-.671-2.568v-9.6a2.192,2.192,0,0,1,.214-1.1,1.231,1.231,0,0,1,.888-.5,2.16,2.16,0,0,0,.67-.195,3.678,3.678,0,0,0,.866-.647,4.375,4.375,0,0,0,.719-1.126,4.347,4.347,0,0,0,.309-1.728,3.6,3.6,0,0,0-.765-2.4,2.917,2.917,0,0,0-1.635-1.006,1.745,1.745,0,0,1-.959-.435,1.356,1.356,0,0,1-.312-1.032v-7.2a4.563,4.563,0,0,1,.554-2.568c.384-.528,1.177-.792,2.5-.888h7.85v33.6h-7.823a3.106,3.106,0,0,1-.5.041,3.118,3.118,0,0,1-1.894-.641Z"
                    transform="translate(3930.992 -1953.05)"
                  ></path>
                </g>
              </g></svg
          ></i>
          <!-- 输入框容器 -->
          <div class="ui-input__input-wrap ui-input__input-container">
            <input
              v-model="inputValue"
              spellcheck="false"
              size="1"
              type="text"
              placeholder="Introduza o código de resgate"
              class="ui-input__input"
              @input="handleInput"
              @focus="handleFocus"
              @blur="handleBlur"
              @keyup.enter="handleSubmit"
            />
          </div>

          <!-- 后缀按钮 -->
          <div class="ui-input__suffix">
            <span
              class="ui-input__suffix-icon ui-paste__text"
              @click="handlePaste"
            >
              Colar
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="content-area">
      <div class="public-introduction _introduction_2xq5t_30">
        <div class="_introduction-inner_2xq5t_57 introduction-inner">
          <div class="_introduction-item_2xq5t_77">
            <div
              class="_introduction-title_2xq5t_83"
              style="position: relative; z-index: 0"
            >
              <div class="_title-container_2xq5t_83">
                <span class="_title-text_2xq5t_101">Descrição da atividade</span
                ><i class="_arrow_2xq5t_118"></i>
              </div>
            </div>
            <div class="">
              1.Insira um código de câmbio para resgatar dinheiro bônus
              diretamente em sua conta após um resgate bem-sucedido (apenas para
              contas que efetuaram o primeiro depósito durante o evento).<br />2.Cada
              código de troca só pode ser utilizado uma vez e será invalidado
              após o uso;<br />3.Utilize o código de troca emitido dentro do
              período de validade; após isso, ele se tornará inválido. Durante o
              período do evento, só pode ser utilizado um código por conta;<br />4.O
              bônus concedido neste evento (excluindo o capital) requer apostar
              5 vezes o valor do bônus (rollover, auditoria ou aposta válida).
              Apostas limitadas a Evento de pesca:Todos os jogos,<br />Evento de
              caça-níqueis:Todos os jogos;<br />5.Esta atividade é limitada ao
              proprietário da conta para receber recompensas. É proibido alugar
              uma conta e não é permitido usar plug-ins, robôs, protocolos de
              exploração, brechas, interfaces, controle de grupo ou outros meios
              técnicos para participar. verificado, a plataforma tem o direito
              de encerrar o login do membro e suspender o uso do site do membro,
              e o direito de confiscar bônus e lucros indevidos sem aviso
              prévio;<br />6.Ao participar deste evento, a plataforma pressupõe
              que o membro concorda e cumpre com os termos e condições
              relevantes. Para evitar mal-entendidos na interpretação do texto,
              a plataforma reserva o direito de interpretar este evento.
            </div>
          </div>
          <div class="_introduction-item_2xq5t_77">
            <div
              class="_introduction-title_2xq5t_83"
              style="position: relative; z-index: 0"
            >
              <div class="_title-container_2xq5t_83">
                <span class="_title-text_2xq5t_101">Termos e Condições</span
                ><i class="_arrow_2xq5t_118"></i>
              </div>
            </div>
            <div class="">
              1. Cada jogador só pode usar uma conta. Várias contas não são
              permitidas. Os jogadores que abrirem contas múltiplas ou
              fraudulentas serão desqualificados do evento, o saldo restante
              poderá ser confiscado e a conta será congelada.<br />2. Este site
              reserva-se o direito de modificar, alterar, encerrar, cancelar,
              recusar ou cancelar esta promoção a seu exclusivo critério.<br />3.
              Os jogadores participantes do evento devem aceitar e cumprir os
              termos deste evento, e a inscrição para esta oferta constitui
              concordância com as regras do evento e termos correspondentes.<br />4.
              Para evitar ambiguidades na compreensão do texto, este site
              reserva-se o direito de interpretação final deste evento.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部固定按钮 -->
    <div class="orkXHvtNM5R_5twq6l5I">
      <button
        class="submit-btn-fixed"
        @click="handleSubmit"
        :disabled="!inputValue.trim() || inputValue.trim().length != 12 || isLoading"
      >
        <span v-if="isLoading" class="loading-spinner"></span>
        <span v-else>Resgatar bônus</span>
      </button>
    </div>

    <div v-if="0" class="bottom-fixed-btn">
      
    </div>
    <event></event>
  </div>
</template>

<script>
import event from '@/components/event.vue';
import { useRedemptionCode, platformRebate } from '@/apis/modules/detail.js';
import { Dialog, Toast } from 'vant';
export default {
  components: {
    event
  },
  data() {
    return {
      title: '',
      content: '',
      isConter: false,
      inputValue: '',
      isFocused: false,
      isLoading: false
    };
  },
  created(e) {
    let { title, content, isConter } = this.$route.query;
    this.title = title || this.$t('_homeTile_tab._CupomRecompensas');
    this.content = content;
    this.isConter = isConter;
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },

    // 处理输入事件
    handleInput(event) {
      this.inputValue = event.target.value.trim();
    },

    // 处理聚焦事件
    handleFocus() {
      this.isFocused = true;
    },

    // 处理失焦事件
    handleBlur() {
      this.isFocused = false;
    },

    // 处理粘贴按钮点击
    async handlePaste() {
      try {
        if (navigator.clipboard && navigator.clipboard.readText) {
          const text = await navigator.clipboard.readText();
          this.inputValue = text;
        }
      } catch (error) {
      }
    },

    // 验证输入内容
    validateInput() {
      const value = this.inputValue.trim();

      if (!value || value.length != 12) {
        //Toast.fail('请输入兑换码');
        return false;
      }

      return true;
    },

    // 提交处理
    handleSubmit() {
      if (!this.validateInput()) {
        return;
      }

      this.isLoading = true;
      try {
        useRedemptionCode({ code: this.inputValue.trim() }).then(
          ({ code, data, msg }) => {
            if (code == 0) {
              Dialog({
                title: 'Recebimento com sucesso',
                message: 'Parabéns, recebeu um bônus de '+this.formatCurrency(data),
                confirmButtonText: this.$t('security._Confirmar')
              });
              return;
            }
            Dialog({
              title: 'A redenção falhou',
              message: msg,
              confirmButtonText: this.$t('security._Confirmar')
            });
          }
        );
      } catch (error) {
        //Toast.fail.error('兑换失败，请稍后重试');
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
:deep(.van-nav-bar) {
  background-color: var(--theme-top-nav-bg);
}
:deep(.van-nav-bar__title) {
  font-size: 0.3rem;
  line-height: normal;
  color: var(--theme-text-color-darken);
}
:deep(.van-nav-bar .van-icon) {
  color: var(--theme-text-color);
}
:deep(.van-nav-bar__placeholder) {
  height: 0.9rem;
}
.ejXficlz5ysFaJf0CHhl {
  background-color: var(--theme-main-bg-color);
  min-height: 5.8rem;
  padding: 0.2rem;
  word-break: break-word;
  color: var(--theme-text-color);
  border-radius: 0.14rem;
  box-shadow: 0 0.03rem 0.1rem 0 rgba(0, 0, 0, 0.06);
}

/* 输入框样式 */
.top-content {
  background-color: var(--theme-main-bg-color);
  border-radius: 0.14rem 0.14rem 0.1rem 0.1rem;
  box-shadow: 0 0.03rem 0.1rem rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  padding: 0.2rem;
  margin: 0.2rem;
}

.box-shadow {
  box-shadow: 0 0.04rem 0.16rem rgba(0, 0, 0, 0.1);
}

._input_1ywvk_30 {
  width: 100%;
}

.ui-input {
  display: flex;
  align-items: center;
  border-radius: 0.16rem;
  padding: 0 0.24rem;
  min-height: 0.68rem;
  border: 0.01rem solid var(--theme-color-line);
  transition: all 0.3s ease;
}

.ui-input--focused {
  border-color: var(--theme-primary-color);
  box-shadow: 0 0 0 0.04rem rgba(from var(--theme-primary-color) r g b / 0.2);
}

.ui-input__prefix {
  display: flex;
  align-items: center;
  margin-right: 0.16rem;
  color: #666;
}

.ui-input__input-wrap {
  flex: 1;
  display: flex;
  align-items: center;
}

.ui-input__input-container {
  width: 100%;
}

.ui-input__input {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.28rem;
  color: var(--theme-text-color-darken);
  padding: 0;
}

.ui-input__input::placeholder {
  color: var(--theme-text-color);
}

.ui-input__suffix {
  display: flex;
  align-items: center;
  margin-left: 0.16rem;
  gap: 0.16rem;
}

.ui-input__suffix-icon {
  cursor: pointer;
  padding: 0.08rem 0.16rem;
  border-radius: 0.08rem;
  transition: background-color 0.3s ease;
}

.ui-input__suffix-icon:hover {
  background-color: rgba(from var(--theme-text-color) r g b / 0.2);
}

.ui-paste__text {
  color: var(--theme-text-color-darken);
  font-size: 0.22rem;
}

/* 内容区域样式 */
.content-area {
  padding-bottom: .3rem; /* 为底部按钮留出空间 */
}

.orkXHvtNM5R_5twq6l5I {
  background-color: var(--theme-main-bg-color);
  bottom: 0;
  -webkit-box-shadow: 0 -0.03rem 0.1rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 -0.03rem 0.1rem 0 rgba(0, 0, 0, 0.1);
  display: -ms-flexbox;
  display: flex;
  -ms-flex: none;
  flex: none;
  height: 1.3rem;
  width: var(--theme-max-width);
  position: fixed;
  z-index: 2;
}
.orkXHvtNM5R_5twq6l5I > button {
  margin: 0.2rem;
  border-radius: 0.1rem;
}


/* 固定按钮样式 */
.submit-btn-fixed {
  width: 100%;
  height: 0.66rem;
  background: linear-gradient(135deg, var(--theme-primary-color), var(--theme-text-color));
  color: white;
  border: none;
  border-radius: 0.16rem;
  font-size: 0.24rem;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  margin: 10px;
  align-items: center;
  justify-content: center;
  gap: 0.16rem;
}

.submit-btn-fixed {
  height: 0.8rem;
  font-size: 0.28rem;
}

.submit-btn-fixed:hover {
  background: linear-gradient(135deg, var(--theme-primary-color), var(--theme-text-color));
  transform: translateY(-0.02rem);
  box-shadow: 0 0.08rem 0.24rem rgba(from var(--theme-text-color) r g b / 0.3);
}

.submit-btn-fixed:active {
  transform: translateY(0);
  background: linear-gradient(135deg, var(--theme-primary-color), var(--theme-text-color));
}

.submit-btn-fixed:disabled {
  background: var(--theme-disabled-bg-color);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.loading-spinner {
  width: 0.24rem;
  height: 0.24rem;
  border: 0.04rem solid #fff;
  border-top: 0.04rem solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.lobby-image svg {
  width: 0.4rem;
  height: 0.4rem;
}

._introduction_2xq5t_30 {
  padding: 0 0.2rem 0.2rem;
}
._introduction-inner_2xq5t_57 {
  padding: 0.2rem;
  color: var(--theme-text-color);
  font-size: 0.26rem;
  line-height: 0.42rem;
  white-space: pre-wrap;
  word-break: break-word;
  background-color: var(--theme-main-bg-color);
  border-radius: 0.1rem;
  box-shadow: 0 0.03rem 0.09rem rgba(0, 0, 0, 0.06);
}

._introduction-inner_2xq5t_57 ._introduction-item_2xq5t_77 {
  margin-bottom: 0.2rem;
}
._introduction-title_2xq5t_83 {
  position: relative;
  z-index: 0;
}

._introduction-inner_2xq5t_57
  ._introduction-item_2xq5t_77
  ._introduction-title_2xq5t_83
  ._title-container_2xq5t_83 {
  position: relative;
  display: inline-block;
  left: -0.28rem;
  height: 0.62rem;
  margin-bottom: 0.2rem;
  max-width: 100%;
}
._introduction-inner_2xq5t_57
  ._introduction-item_2xq5t_77
  ._introduction-title_2xq5t_83
  ._title-container_2xq5t_83
  ::before {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0.08rem;
  height: 0.1rem;
  background-color: var(--theme-btm-def-color);
  border-bottom-left-radius: 0.06rem;
}

._introduction-inner_2xq5t_57
  ._introduction-item_2xq5t_77
  ._introduction-title_2xq5t_83
  ._title-container_2xq5t_83
  ._title-text_2xq5t_101 {
  position: relative;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-left: 0.28rem;
  padding-right: 0.1rem;
  font-size: 0.32rem;
  height: 0.56rem;
  line-height: 0.56rem;
  color: var(--theme-text-color-task-btn);
  background-color: var(--theme-btm-def-color);
  border-top-left-radius: 0.06rem;
  z-index: 1;
}
._introduction-inner_2xq5t_57
  ._introduction-item_2xq5t_77
  ._introduction-title_2xq5t_83
  ._title-container_2xq5t_83
  ._arrow_2xq5t_118 {
  position: absolute;
  top: 0;
  right: -0.26rem;
  width: 0.28rem;
  height: 0.56rem;
  overflow: hidden;
  z-index: 0;
}
._introduction-inner_2xq5t_57
  ._introduction-item_2xq5t_77
  ._introduction-title_2xq5t_83
  ._title-container_2xq5t_83
  ._arrow_2xq5t_118::after {
  content: '';
  position: absolute;
  top: -0.04rem;
  left: 0;
  border: 0.32rem solid transparent;
  border-left-color: var(--theme-btm-def-color);
}

._introduction-inner_2xq5t_57
  ._introduction-item_2xq5t_77
  ._introduction-title_2xq5t_83
  ._title-container_2xq5t_83::after {
  content: '';
  position: absolute;
  top: 0.24rem;
  right: -0.28rem;
  width: 0.08rem;
  height: 0.08rem;
  background-color: var(--theme-btm-def-color);
  border-radius: 50%;
  z-index: 1;
}
.aaaa {
  background-color: #eef5ff;
}
</style>
